module.exports = __webpack_public_path__ + "static/img/684_phase_function_Paper_PointsHejduk_Prediction.a222309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/684_phase_function_Paper_PointsHejduk_Prediction.png
// module id = o+lg
// module chunks = 0